import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { FlightCheckDashboard } from '../../../components/flight-check/FlightCheckDashboard.js';
import { FlightCheckPage } from '../../../components/flight-check/FlightCheckPage.js';
import {
  CenteredSpinner,
  EmptyState,
  LoadError,
} from '../../../components/flight-check/FlightCheckParts.js';
import { toDashboardView } from '../../../components/flight-check/flightCheckView.js';
import { useViewBatch } from '../../../components/flight-check/useViewBatch.js';
import { useTRPC } from '../../../lib/trpc.js';

export function FlightCheckDashboardRoute(): ReactNode {
  const trpc = useTRPC();
  const viewBatch = useViewBatch();
  const overview = useQuery(trpc.flightCheck.overview.queryOptions());
  const copy = overview.data?.flightCheckCopy;

  let body: ReactNode;
  if (overview.isPending) body = <CenteredSpinner />;
  else if (overview.isError) body = <LoadError onRetry={() => void overview.refetch()} />;
  else if (overview.data.kpis.batches === 0 && overview.data.latestBatch === null) {
    body = (
      <EmptyState
        title={overview.data.flightCheckCopy.emptyTitle}
        body={overview.data.flightCheckCopy.emptyBody}
      />
    );
  } else {
    body = (
      <FlightCheckDashboard
        data={toDashboardView(overview.data)}
        copy={overview.data.flightCheckCopy}
        onViewBatch={viewBatch}
      />
    );
  }

  return (
    <FlightCheckPage title={copy?.title} subtitle={copy?.subtitle} tab="dashboard">
      {body}
    </FlightCheckPage>
  );
}

export const Route = createFileRoute('/flight-check/dashboard/')({
  component: FlightCheckDashboardRoute,
});
